import { BaseError } from "./base.js";
export class InvalidUserOperationError extends BaseError {
    constructor(uo) {
        super(`Request is missing parameters. All properties on UserOperationStruct must be set. uo: ${JSON.stringify(uo, null, 2)}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidUserOperationError"
        });
    }
}
//# sourceMappingURL=useroperation.js.map